import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from "vue";
  import { useIsDesktop } from "@/features/useIsDesktop";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'BuilderGetStartedTab',
  props: {
    buttonDisabled: { type: Boolean }
  },
  emits: ["onRequestQuote"],
  setup(__props: any, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emits = __emit;
  const { isDesktop } = useIsDesktop(681);
  const imagesArray = [
    "1_23.09.27_2138_S18ASP_R1_01.jpg",
    "2_23.09.14_2131_S19ASQN_R2_01.jpg",
    "3_23.02.13_S3ASC_R2_01 (2).jpg",
    "4_21.06.02_Series96_AnnixHomes_R2_01 (1).jpg",
    "5_21.06.02_Series96_AnnixHomes_R4_01.jpg",
  ];

  const carouselImages = ref([...imagesArray, ...imagesArray]);

  const builderCarousel = ref();

  const handleScroll = () => {
    const viewportWidth = builderCarousel.value.clientWidth;
    const scrollLeft = builderCarousel.value.scrollLeft;
    const maxScroll = builderCarousel.value.scrollWidth - viewportWidth;
    const tolerance = 20;

    if (maxScroll - scrollLeft < viewportWidth / 2 + tolerance) {
      carouselImages.value = [...carouselImages.value, ...imagesArray];
    }
  };

const __returned__ = { props, emits, isDesktop, imagesArray, carouselImages, builderCarousel, handleScroll, computed, ref, watch, get useIsDesktop() { return useIsDesktop } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})